export enum RelationshipToPrimaryOwner {
  Spouse = 1,
  DomesticPartner = 2,
  Parent = 3,
  LegalGuardian = 4,
  Child = 5,
  Sibling = 6,
  OtherRelative = 7,
  BusinessPartnerOrCoOwner = 8,
  AccountantOrBookkeeper = 9,
  Employee = 10,
  TrusteeOrPowerOfAttorney = 11,
  Friend = 12,
  Other = 13,
}

export enum EmploymentType {
  EmployedFullTime = 1,
  EmployedPartTime = 2,
  SelfEmployedOrFreelancer = 3,
  Student = 4,
  Homemaker = 5,
  Caregiver = 6,
  Retired = 7,
  Unemployed = 8,
}

export enum DigitalBankingRole {
  Admin = 1,
  User = 2,
  ViewOnly = 3,
}

export enum GovernmentIdType {
  StateIssuedID = 1,
  Passport = 2,
}

export enum ReasonPhysicalAddressIsDifferentThanIdAddressType {
  MovedToCurrentPhysicalAddress = 1,
  Other = 9,
}

export enum SecurityQuestion {
  MothersMiddleName = 1,
  FathersMiddleName = 2,
  FirstCarMake = 3,
  FavoriteSportsTeam = 4,
  ElementarySchoolName = 5,
  HighSchoolMascot = 6,
}

export enum FinancialApplicationSection {
  AllSections = -1,
  PersonInformationBasicInfo = 1,
  // PersonInformationContactInfo = 2,
  // EmploymentInformation = 3,
  // DigitalBankingInformation = 4,
  // DebitCardInformation = 5,
  // GovernmentIdInformation = 6,
  OrganizationInformation = 7,
  PersonalAccountAcceptableUse = 8,
  // OrganizationContactInformation = 9,
  PersonalAccountRiskReview = 10,
  LawFirmOrganizationAccountRiskReview = 11,
  NonLawFirmOrganizationAccountRiskReview = 12,
  OptIns = 13,
  FinancialApplicationDocuments = 14,
  OrganizationAccountAcceptableUse = 15,
  KeyPeople = 16,
  JointAccountOwners = 17,
  PersonalAccountBeneficiaries = 18,
  ProductSelection = 19,
  DisclosureAcknowledgements = 20,
  AccountDetails = 21,
}

export enum RiskReviewColors {
  Green = 1,
  Yellow = 2,
  Red = 3,
  NotApplicable = 4,
}

export enum ShareApplicationRole {
  Applicant = 1,
  JointOwner = 2,
  KeyPerson = 3,
}

export enum UserAccountStatus {
  Unlinked = 1,
  InviteCreated = 2,
  InviteSent = 3,
  Linked = 4,
  InviteExpired = 5,
}

export enum PositivePayDecision {
  Pay = 1,
  Return = 2,
}

export enum ComputerType {
  PC = 1,
  Mac = 2,
}

// Utility functions for enum display names
export const getShareApplicationRoleDisplayName = (role: ShareApplicationRole): string => {
  switch (role) {
    case ShareApplicationRole.Applicant:
      return "Applicant";
    case ShareApplicationRole.JointOwner:
      return "Joint Owner";
    case ShareApplicationRole.KeyPerson:
      return "Key Person";
    default:
      return "Unknown";
  }
};

export const getUserAccountStatusDisplayName = (status: UserAccountStatus): string => {
  switch (status) {
    case UserAccountStatus.Unlinked:
      return "Unlinked";
    case UserAccountStatus.InviteCreated:
      return "Invite Created";
    case UserAccountStatus.InviteSent:
      return "Invite Sent";
    case UserAccountStatus.Linked:
      return "Linked";
    case UserAccountStatus.InviteExpired:
      return "Invite Expired";
    default:
      return "Unknown";
  }
};
